"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColourGeneralHandler", {
    enumerable: true,
    get: function() {
        return ColourGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
const _generic = require("~/db/field-handler/handlers/generic");
let ColourGeneralHandler = class ColourGeneralHandler extends _generic.GenericFieldHandler {
    /**
   * Validate and normalise user input for a Colour field.
   *
   * Accepts hex colours with or without a `#` prefix (e.g. `FF5733` or
   * `#ff5733`).  The value is normalised to uppercase `#RRGGBB` format.
   * Invalid input triggers {@link NcError.invalidValueForField}.
   */ async parseUserInput(params) {
        const { value, column } = params;
        if (!value) {
            return {
                value: null
            };
        }
        const normalized = (0, _nocodbsdk.normalizeHexColour)(value);
        if (!normalized) {
            _catchError.NcError.invalidValueForField({
                value,
                column: column.title,
                type: column.uidt
            });
        }
        return {
            value: normalized
        };
    }
};
